module.exports = __webpack_public_path__ + "img/spl-2024-sidebar-tablet.4655f98.png";